export default function Guides() {
  return (
    <div className="min-h-[60vh] py-16 px-4 md:px-8" data-testid="guides-page">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase">Guides</h1>
        <p className="text-zinc-400 mt-4">Guides for Cape Town film and video crews are coming soon.</p>
      </div>
    </div>
  );
}
